<template>
    <div class="button_page_up" @click="upToTop" :style="{'opacity':cssOpacity}">
        <div ref="button_arrow_up_ref" class="button_arrow_up" @click="upToTop" :style="{'opacity':cssOpacity}">
            <i class="fas fa-chevron-up"></i>
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return {
            cssOpacity: 0
        }
    },
    created () {
        window.addEventListener('scroll', this.handleScroll);
    },
    unmounted () {
        window.removeEventListener('scroll', this.handleScroll);
    },
    methods:{
        upToTop(){
            window.scrollTo(0,0);
        },
        handleScroll(event){
            if(window.scrollY > 1700){
                document.querySelector('.button_page_up').style.display = 'block';
            }
            if(window.scrollY > 2000){
                this.cssOpacity = 1;
            }else{
                this.cssOpacity = 0;
                document.querySelector('.button_page_up').style.display = 'none';
            }
        }
    }
}
</script>

<style scoped>

.button_page_up{
    position: fixed;
    /* background: #3d3d3d2b; */
    width: 92px;
    height: 100vh;
    bottom: 0;
    cursor: pointer;
    transition: .3s;
}
.button_page_up:hover{
    background-color: #5b5b5b2b;
}

.button_arrow_up {
  position: fixed;
  bottom: 20px;
  left: 20px;
  background-color:  rgb(43 43 43 / 80%);
  width: 50px;
  height: 50px;
  border-radius: 50%;
  border: 1px solid #414141;
  z-index: 999;
  cursor: pointer;
  transition: .3s;
}



.button_arrow_up .fa-chevron-up{
    padding: 17px;
}

.telegram-icon {
  width: 25px;
  height: 25px;
  margin: 13px 11px;
}


@media only screen and (max-width: 768px) {
  .button_page_up{
    height: 0;
  }
}
</style>